export enum SPECS {
  WISHLIST_ENABLED = 'specs.stores.WishlistEnabled',
  BUY_NOW_BUTTON_ENABLED = 'specs.stores.BuyNow',
}
